// extracted by mini-css-extract-plugin
export var item = "ProductItem-module--item--mk7T-";
export var brand_button_docs = "ProductItem-module--brand_button_docs--sS-pS";
export var brand_button_inspection = "ProductItem-module--brand_button_inspection--Y+IqL";
export var brand_button_tools = "ProductItem-module--brand_button_tools--Ermdu";
export var brand_button_dashboard = "ProductItem-module--brand_button_dashboard--5xblq";
export var item_docs = "ProductItem-module--item_docs--1xYgc";
export var item_inspection = "ProductItem-module--item_inspection--4FwyL";
export var item_tools = "ProductItem-module--item_tools--6faVm";
export var item_dashboard = "ProductItem-module--item_dashboard--0RV2q";
export var item_content = "ProductItem-module--item_content--GmiSL";
export var brand_button = "ProductItem-module--brand_button--t2DjM";
export var logo = "ProductItem-module--logo--YY3Fh";
export var module_text = "ProductItem-module--module_text--8X5lv";
export var modules = "ProductItem-module--modules--mZIWF";
export var subtitle = "ProductItem-module--subtitle--c0qQM";
export var list = "ProductItem-module--list--HDf4U";
export var list_item = "ProductItem-module--list_item--etg4L";
export var desktop_dashboard = "ProductItem-module--desktop_dashboard--+r5KC";
export var is_mobile = "ProductItem-module--is_mobile--zWizS";
export var is_desktop = "ProductItem-module--is_desktop--AWo5l";